import { PieChart, Pie, Cell } from 'recharts';
import { s } from './ResultReport.styles';

type Props = {
  totalCnt: number | string;
  successCnt: number | string;
};

function PieChartGraph({ totalCnt, successCnt }: Props) {
  const total = Number(totalCnt);
  const success = Number(successCnt);
  const fail = total - success; // 전체 - 성공 = 실패 or 나머지

  const data = [
    {
      name: '수익(Win) 물건 수',
      value: success,
      color: '#008AFF',
      displayValue: successCnt,
    },
    {
      name: '전체 경매 건수',
      value: fail,
      color: '#D2D8DF',
      displayValue: totalCnt,
    },
  ];
  const reverseData = data.toReversed();

  return (
    <s.GraphContainer>
      <s.GraphWrapper>
        <PieChart width={120} height={120}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={60}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            stroke="none"
            paddingAngle={5}
          >
            {data.map((item, index) => (
              <Cell key={`cell-${index}`} fill={item.color} />
            ))}
          </Pie>
        </PieChart>
      </s.GraphWrapper>

      <s.DataColumn>
        {reverseData.map((item) => (
          <s.DataItem key={item.name}>
            <s.LegendColor $bg={item.color} />
            <s.ItemContent>
              <s.ItemLabel>{item.name}</s.ItemLabel>
              <s.ItemValue>{item.displayValue.toLocaleString()}</s.ItemValue>
            </s.ItemContent>
          </s.DataItem>
        ))}
      </s.DataColumn>
    </s.GraphContainer>
  );
}

export default PieChartGraph;
